import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

import { ref } from 'vue';
import type { FormField } from '@/types/form';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeKanbanStatusForm',
  props: {
    fields: {},
    formTitle: {},
    onSubmit: { type: Function },
    onCancel: { type: Function }
  },
  setup(__props: any) {



const form = ref<Record<string, any>>({});
const formRef = ref();
const formValid = ref(true);

// Inicializa el form
__props.fields.forEach((f) => {
  if (f.isJsonArray) {
    form.value[f.value] = [{}]; // array de un objeto vacío
  } else {
    form.value[f.value] = '';
  }
});


const getFieldProps = (field: FormField) => {
  const props: Record<string, any> = {
    label: field.label,
    placeholder: field.placeholder ?? '',
    clearable: true,
    density: 'compact',
    type: field.type || 'text',
    prefix: field.prefix,
    suffix: field.suffix,
    'prepend-inner-icon': field.icon,
    disabled: field.permission === 'disabled',
    readonly: field.readonly,
  };

  if (field.options) {
    props.items = field.options;
    props['item-title'] = field.itemText || 'text';
    props['item-value'] = field.itemValue || 'value';
  }

  return props;
};

const submitForm = () => {
  if (!formRef.value?.validate()) return;
  __props.onSubmit({ ...form.value });
};

const cancelForm = () => {
  __props.onCancel?.();
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submitForm, ["prevent"]),
    ref_key: "formRef",
    ref: formRef,
    modelValue: formValid.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValid).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "px-5 py-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center mb-3" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.formTitle), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (!_ctx.fields?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_alert, {
                      type: "warning",
                      border: "start",
                      prominent: ""
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" No hay campos definidos para este formulario. ")
                      ])),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          key: field.value,
                          cols: 12,
                          md: field.col || 12,
                          sm: field.mdcol || 12
                        }, {
                          default: _withCtx(() => [
                            (!field.isJsonArray)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), _mergeProps({
                                  key: 0,
                                  modelValue: form.value[field.value],
                                  "onUpdate:modelValue": ($event: any) => ((form.value[field.value]) = $event),
                                  ref_for: true
                                }, getFieldProps(field), {
                                  rules: field.required ? [v => !!v || 'Campo obligatorio'] : []
                                }), null, 16, ["modelValue", "onUpdate:modelValue", "rules"]))
                              : (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), {
                                  key: 1,
                                  modelValue: form.value[field.value],
                                  "onUpdate:modelValue": ($event: any) => ((form.value[field.value]) = $event),
                                  fields: field.children,
                                  label: field.label,
                                  summary: field.summary,
                                  multiple: _ctx.multiple
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "fields", "label", "summary", "multiple"]))
                          ]),
                          _: 2
                        }, 1032, ["md", "sm"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: cancelForm
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Cancelar")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "secondary",
                disabled: !formValid.value
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Confirmar")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})